import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@emotion/react';



const Colortheme = () => {
  const theme: any = useTheme();
  const cardbg = theme.palette.cardbg.main;
  const inherit = theme.palette.inherit.main;
  const inherit200 = theme.palette.inherit200.main;
  const pricebg = theme.palette.pricebg.main;
  const textmuted = theme.palette.textmuted.main;
  const primary = theme.palette.primary.main;
  const primaryBgSubtle = theme.palette.primaryBgSubtle.main;
  const dangerbtnbg = theme.palette.dangerbtnbg.main;
  const dangerbagdebg = theme.palette.dangerbagdebg.main;
  const secondary = theme.palette.secondary.main;
  const success = theme.palette.success.main;
  const successBgSubtle = theme.palette.successBgSubtle.main;
  const secondaryBgSubtle = theme.palette.secondaryBgSubtle.main;
  const warning = theme.palette.warning.main;
  const warningBgSubtle = theme.palette.warningBgSubtle.main;
  const danger = theme.palette.danger.main;
  const dangerBgSubtle = theme.palette.dangerBgSubtle.main;
  const info = theme.palette.info.main;
  const infoBgSubtle = theme.palette.infoBgSubtle.main;
  const light = theme.palette.light.main;
  const dark = theme.palette.dark.main;
  const productimgbg = theme.palette.productbg.main; //same as product
  const cardBorder = theme.palette.primary.light; // same as card
  const infoLight = theme.palette.info.light;
  const borderColor = theme.palette.primary.light; // same as card
  const primarybtnbg = theme.palette.primarybtnbg.main;
  const dropdownBg = theme.palette.dropdownbg.main;
  const productbg = theme.palette.productbg.main; //same as product
  const textDark = theme.palette.textDark.main;
  const white50 = theme.palette.white50.main;
  const white = theme.palette.white.main;
  const textbody = theme.palette.textbody.main;
  const textlight = theme.palette.textlight.main;
  const white75 = theme.palette.white75.main;
  const bodytheme = theme.palette.bodytheme.main;
  const bodycolor = theme.palette.bodycolor.main;
  const infobtnbg = theme.palette.infobtnbg.main;
  const darkbtnbg = theme.palette.darkbtnbg.main;
  const revenueBg = theme.palette.revenueBg.light;
  const error = theme.palette.error.main;
  const sidebarpage = theme.palette.sidebar.title
  const sidebarBg = theme.palette.sidebar.main;
  const sidebarTitle = theme.palette.sidebar.title;
  const sidebarLink = theme.palette.sidebar.link;
  const sidebarLinkHover = theme.palette.sidebar.linkHover;
  const sidebarLinkHoverFill = theme.palette.sidebar.linkHoverFill;
  const sidebarFontSize = theme.typography.sidebar.main;
  const selectmenu = theme.palette.selectmenu.main;
  


  return {
    cardbg,
    inherit,
    inherit200,
    textmuted,
    primary,
    primaryBgSubtle,
    secondary,
    success,
    successBgSubtle,
    textDark,
    secondaryBgSubtle,
    warning,
    warningBgSubtle,
    danger,
    dangerBgSubtle,
    info,
    infoBgSubtle,
    light,
    dark,
    productimgbg,
    cardBorder,
    infoLight,
    borderColor,
    primarybtnbg,
    dropdownBg,
    productbg,
    white50,
    white,
    textbody,
    textlight,
    white75,
    bodytheme,
    bodycolor,
    infobtnbg,
    darkbtnbg,
    revenueBg,
    error,
    sidebarpage,
    sidebarBg,
    sidebarTitle,
    sidebarLink,
    sidebarLinkHover,
    sidebarLinkHoverFill,
    sidebarFontSize,
    dangerbtnbg,
    dangerbagdebg,
    pricebg,
    selectmenu
  }
}


const useStyles: any = makeStyles((theme: any) => ({

  cardCommam: {
    border: `1px solid #438eff1a`,
    borderRadius: '6px',
  },
  cardbody: {
    padding: '20px',
  },
  cardTitle: {
    '&.MuiTypography-root.MuiTypography-h6': {
      fontSize: '16px',
      fontWeight: 600,
    }
  },
  textfield: {
    '& .MuiOutlinedInput-input': {
      padding: '9px 14px',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.primary.light, // Default border color
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.light, // Default border color
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #a1c7ff',
        boxShadow: '0 0 0 0.25rem rgba(67,142,255,0.25)',
      },
    },
    '& .MuiInputBase-input': {
      '& :placeholder': {
        color: theme.palette.mode === 'light' ? '#a9a9a9' : '#fff',
        fontSize: '14px',
      },
    },
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
  },
  paper: {
    padding: theme.spacing(2),
    width: 300,
  },
  customAdornment: {
    backgroundColor: '#f3f6f9', // Replace with your desired background color
    padding: '21px',
  },
  '@keyframes grow': {
    '0%': {
      transform: 'scale(0.8)',
    },
    '100%': {
      transform: 'scale(1.2)',
    },
  },
  roundButton: {
    borderRadius: '300px',
    width: '40px', // Adjust the width to fit your requirements
    height: '40px', // Adjust the height to fit your requirements 
    animation: '$grow 1s infinite alternate',
    color: 'white', // Adjust the text color
    '&:hover': {
      color: 'white',
      backgroundColor: 'white', // Adjust the hover background color
    },
  },
  headerDropdown: {
    '& .css-6hp17o-MuiList-root-MuiMenu-list': {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
    '& .css-h4y409-MuiList-root': {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
    '& .css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper': {
      boxShadow: 'none'
    },
    '& .css-kc02vp-MuiPaper-root-MuiPopover-paper-MuiMenu-paper': {
      boxShadow: 'none'
    }
    
  },
  sidebar: {
    '& .css-1itdr1j-MuiButtonBase-root-MuiListItemButton-root:hover': {
      backgroundColor: 'transparent',
    },
    '& .css-gg5eqr-MuiButtonBase-root-MuiListItemButton-root:hover': {
      backgroundColor: 'transparent',
    },
    '& .css-1kez0ti-MuiButtonBase-root-MuiListItemButton-root:hover': {
      backgroundColor: 'transparent',
    },
    '&.css-8pwymf-MuiDrawer-docked .MuiDrawer-paper': {
      border: 'inherit',
      display: 'none'
    },
    '&.MuiDrawer-root .MuiPaper-elevation': {
      // background: '#ecf3ff',
      zIndex: document.documentElement.clientWidth < 1025 ? '1201' : '1200',
      [theme.breakpoints.down('md')]: {
        position: 'fixed',
        top: '0',
        left: '0',
        zIndex: '1201'
      }
    },
    '&.MuiDrawer-root .MuiDrawer-modal':{
      zIndex:'1300',
    },

    '& .MuiListItem-root:hover': {
      '& .css-1vsrmwh-MuiListItemText-root': {
        opacity: 1,
        position: 'absolute',
        left: '60px',
        top: '10px',
        padding: '0 8px',
        color: theme.palette.mode === 'light ' ? '#fff !important' : '#1c2932 !important',
      },
      '& .css-1cag644-MuiListItemText-root': {
        opacity: 1,
        marginLeft: '40px',
        color: theme.palette.mode === 'light ' ? '#fff !important' : '#1c2932 !important',
      },
    },

    '& .css-1vsrmwh-MuiListItemText-root:hover': {
      '& .MuiCollapse-root': {
        visibility: 'visible',
        overflow: 'visible'
      }

    }

  },

}));



export { Colortheme }
export default useStyles